module.exports = __webpack_public_path__ + "img/sign-59.95d9d024.jpg";